import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { CodeGlyph } from '@/components/brand/logo-mark'
import { cn } from '@/lib/utils'

interface ProjectImageProps {
    src: string | null
    alt: string
    sizes: string
    priority?: boolean
    className?: string
}

// Fills its (relatively positioned) parent. Local images are optimized; images uploaded
// through the CMS live on the storage CDN and are shown as they are.
export const ProjectImage: FC<ProjectImageProps> = ({
    src,
    alt,
    sizes,
    priority = false,
    className
}): ReactNode => {
    if (!src) {
        return (
            <div className={cn('absolute inset-0 grid place-items-center bg-gradient-to-br from-brand/50 via-card to-background', className)}>
                <CodeGlyph className='w-16 text-white/40' />
            </div>
        )
    }

    return (
        <Image
            src={src}
            alt={alt}
            fill
            sizes={sizes}
            preload={priority}
            fetchPriority={priority ? 'high' : undefined}
            unoptimized={/^https?:\/\//i.test(src)}
            className={cn('object-cover', className)}
        />
    )
}
